module.exports = __webpack_public_path__ + "media/images/loading-1a32f552ee5280e2aef9725bd6d78652.gif";